module.exports = __webpack_public_path__ + "static/media/jacksonville-catering-hero.f4c12357.jpg";